// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ca_J","title":"styles_title__3fUlB"};